export default __webpack_public_path__ + "static/media/step2.3980823a.png";